import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {};

const step2Slice = createSlice({
  name: "CancerCover-Step2",
  initialState,
  reducers: {
    updateToIntialState2: (state, action: PayloadAction<any>) => ({
      ...initialState,
    }),
  },
  extraReducers: {},
});

export const { updateToIntialState2 } = step2Slice.actions;

export default step2Slice.reducer;
